import * as React from "react";
export var CurrentTradeDetailsContext = React.createContext({
  data: null,
  loading: true,
  changeData: true
});
CurrentTradeDetailsContext.displayName = "CurrentTradeDetailsContext";